/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ChargeSort {
  STATUS = 'status',
  CHARGE_DATE = 'charge_date',
  COMPANY = 'company',
  DUE_DATE = 'due_date',
  PAID_DATE = 'paid_date',
  DESCRIPTION = 'description',
  AMOUNT = 'amount',
  UNPAID_AMOUNT = 'unpaid_amount',
}
